import { c as _c } from "react/compiler-runtime";
import CircleLoader from "@/components/distribution-plan-tool/common/CircleLoader";
export default function UserPageIdentityStatementsConsolidatedAddressesItemPrimary(t0) {
  const $ = _c(7);
  const {
    isPrimary,
    canEdit,
    assignPrimary,
    isAssigningPrimary
  } = t0;
  if (isPrimary) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <span className="tw-ml-1 tw-text-xs tw-font-bold tw-text-iron-500">Primary</span>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (canEdit) {
    let t1;
    if ($[1] !== isAssigningPrimary) {
      t1 = isAssigningPrimary ? <CircleLoader /> : <>Set Primary</>;
      $[1] = isAssigningPrimary;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    let t2;
    if ($[3] !== assignPrimary || $[4] !== isAssigningPrimary || $[5] !== t1) {
      t2 = <button disabled={isAssigningPrimary} onClick={assignPrimary} className="tw-bg-transparent tw-whitespace-nowrap tw-border-none tw-ml-1 tw-text-xs tw-font-bold tw-text-iron-500 hover:tw-text-primary-400 tw-transition tw-duration-300 tw-ease-out">{t1}</button>;
      $[3] = assignPrimary;
      $[4] = isAssigningPrimary;
      $[5] = t1;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    return t2;
  }
  return null;
}